import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Generates hidden version of the template. It produces clean
 * markup for use in template that is sent to BE. 
 * It ensures template has no markup leftover 
 * from user interactions and allows us to include "intro" modal 
 */
export const Markup = ({saveInteractive, template, ...props}) => {
  const templateRef = useRef();
  const interactive = useSelector(state => state.interactive);
  const [saving,setSaving] = useState(false);

  useEffect( () => {
    if (!saving) {
      setSaving(true);
      saveInteractive(templateRef);
    }
  }, [saveInteractive,saving])

  const Template = template;

  return (
    <div style={{display: 'none'}}>
      <Template {...interactive} ref={templateRef}/>
    </div>
  )
}


Markup.propTypes = {
  template: PropTypes.elementType.isRequired
}